import { useTranslation } from 'react-i18next'

export function InfoEmailSection() {
  const { t } = useTranslation('proposal', { keyPrefix: 'Proposal.InfoEmailSection' })
  return (
    <div className='grid lg:grid-cols-10'>
      <div dangerouslySetInnerHTML={{ __html: t('Text') }} className='lg:col-span-9'></div>
    </div>
  )
}
